export const infraConfig = {
    apiEndpoint : "http://localhost:4001",
    usePort: true,
    clientId: '0f7a3860-6f61-40a6-9684-65a00904e148', // minsida client
    identityServerEndpoint : "https://login.windows.net/portalplusdemo.onmicrosoft.com/v2.0/",
    documentsUrl: "https://minsidabn-docs.azurewebsites.net"
};

